class ContentSlider extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-panel]')];
    this.index = 0;

    this.querySelectorAll('[data-prev]').forEach((btn) => btn.addEventListener('click', () => this.go(-1)));
    this.querySelectorAll('[data-next]').forEach((btn) => btn.addEventListener('click', () => this.go(1)));
  }

  go(step) {
    const focusedNext = document.activeElement?.hasAttribute('data-next');
    this.index = (this.index + step + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.classList.toggle('opacity-0', !active);
      slide.classList.toggle('invisible', !active);
      slide.inert = !active;
    });
    this.slides[this.index].querySelector(focusedNext ? '[data-next]' : '[data-prev]')?.focus();
  }
}

customElements.define('content-slider', ContentSlider);
